export default __webpack_public_path__ + "static/media/right-icon.0e5cc709.svg";